<template>
  <BaseLayoutLogin>
    <!-- ALTERAR SENHA -->
    <form v-if="!success" class="form" @submit="resetPassword">
      <!-- SENHA -->
      <FormInput
        v-model="password"
        :class="{ 'form-error': error }"
        label="Nova senha"
        placeholder="Insira sua senha"
        type="password"
        class="form--password"
      />
      <!-- CONFIRMAR SENHA -->
      <FormInput
        v-model="confirmPassword"
        :class="{ 'form-error': error }"
        label="Confirmar nova senha"
        placeholder="Insira sua senha"
        type="password"
        class="form--confirm-password"
      />
      <!-- INSTRUÇÕES PARA TROCAR DE SENHA -->
      <div class="form--instructions">
        <PmwParagraph size="paragraph-40" fontSize="small"
          ><b>A senha deve possuir:</b></PmwParagraph
        >
        <ul>
          <li>
            <PmwParagraph
              :class="{ valid: checkNumberCharacteres() }"
              size="paragraph-40"
              fontSize="small"
            >
              - no mínimo 12 caracteres;
            </PmwParagraph>
          </li>
          <li>
            <PmwParagraph
              :class="{ valid: checkHasNumber() }"
              size="paragraph-40"
              fontSize="small"
            >
              - pelo menos 1 número;
            </PmwParagraph>
          </li>
          <li>
            <PmwParagraph
              :class="{ valid: checkLowerCase() }"
              size="paragraph-40"
              fontSize="small"
            >
              - pelo menos 1 letra minúscula;
            </PmwParagraph>
          </li>
          <li>
            <PmwParagraph
              :class="{ valid: checkUpperCase() }"
              size="paragraph-40"
              fontSize="small"
            >
              - pelo menos 1 letra maiúscula;
            </PmwParagraph>
          </li>
          <li>
            <PmwParagraph
              :class="{ valid: checkSpecialChars() }"
              size="paragraph-40"
              fontSize="small"
            >
              - pelo menos 1 caractere especial.
            </PmwParagraph>
          </li>
        </ul>
      </div>
      <!-- FEEDBACK DE ERRO -->
      <div class="form--feedback">
        <PmwParagraph v-if="error" size="paragraph-40" fontSize="small">
          <span>{{ message }}</span>
        </PmwParagraph>
      </div>
      <div class="form--buttons">
        <PmwButton
          class="form--buttons__back"
          type="button"
          layout="outline"
          element="router-link"
          link="/login"
        >
          Voltar
        </PmwButton>
        <PmwButton :disabled="loading" type="submit">
          Atualizar
        </PmwButton>
      </div>
    </form>
    <!-- SUCESSO -->
    <div v-if="success" class="form-success">
      <PmwParagraph
        size="paragraph-80"
        weight="500"
        class="form-success--title"
        level="2"
        >Sucesso!</PmwParagraph
      >
      <PmwParagraph class="form-success--message">
        Senha redefinida com sucesso.
      </PmwParagraph>
      <Icon class="form-success--icon" icon="check" />
      <PmwButton
        type="button"
        element="router-link"
        link="/login"
        class="form-success--button"
      >
        Login
      </PmwButton>
    </div>
  </BaseLayoutLogin>
</template>

<script>
import BaseLayoutLogin from '@/layouts/BaseLayoutLogin'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'

export default {
  name: 'ResetPassword',
  components: {
    BaseLayoutLogin,
    FormInput,
    PmwParagraph,
    PmwButton,
    Icon
  },
  data() {
    return {
      id: this.$route.query.id,
      token: this.$route.query.token,
      password: null,
      confirmPassword: null,
      error: false,
      message: null,
      success: false,
      /** Se o formulário está carregando */
      loading: false
    }
  },
  created() {
    /** Conferir se há as informações para acessar essa tela */
    this.checkParams()
  },
  methods: {
    /** Redefinir a senha
     * @param {Event} e - Capturar evento do formulário de redefinição de senha
     */
    async resetPassword(e) {
      /** Carregando loading */
      this.loading = true

      e.preventDefault()
      /** Limpar erros */
      this.clearErrors()
      /** Verificar se as senhas são iguais */
      if (!this.checkEqualPasswords()) {
        this.message = 'As senhas são diferentes'
        this.error = true
        this.loading = false
        return
      }
      await this.$auth
        .resetPassword({
          id: this.id,
          token: this.token,
          novaSenha: this.password
        })
        .then((response) => {
          if (response.data.sucesso) {
            this.success = true
          } else {
            this.message = response.data.message
            this.error = true
          }
        })
        .catch((e) => {
          this.error = true
          if (e.response.data.message) {
            this.message = e.response.data.message
          } else {
            this.message = 'Houve um erro ao redefinir sua senha.'
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** Limpar erros */
    clearErrors() {
      this.error = false
      this.message = ''
    },
    /** Conferir parâmetros */
    checkParams() {
      if (!this.id || !this.token) {
        window.location = '/Admin/v2/login'
      }
    },
    /** Validar número de caracteres */
    checkNumberCharacteres() {
      return this.password && this.password.length >= 12 ? true : false
    },
    /** Validar se há números */
    checkHasNumber() {
      return this.password && /\d/.test(this.password) ? true : false
    },
    /** Validar as letras masculinas */
    checkUpperCase() {
      return this.password && this.password.toLowerCase() !== this.password
        ? true
        : false
    },
    /** Validar as letras minúsculas */
    checkLowerCase() {
      return this.password && this.password.toUpperCase() !== this.password
        ? true
        : false
    },
    /** Validar os caracteres especiais */
    checkSpecialChars() {
      const character = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
      return this.password && character.test(this.password) ? true : false
    },
    /** Validar se as senhas são iguais */
    checkEqualPasswords() {
      return this.password === this.confirmPassword
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  padding: 30px 30px 33px 30px;

  &--password {
    margin-bottom: 25px;
  }

  &--confirm-password {
    margin-bottom: 25px;
  }

  &--feedback {
    color: $error;
    margin-bottom: 15px;
    text-align: center;
  }

  &--message {
    color: $gray-dark;
    margin-bottom: 40px;
    text-align: center;
    line-height: 14px;
    b {
      font-weight: 700;
    }
  }

  &--instructions {
    color: $gray-dark;
    line-height: 14px;
    margin-bottom: 20px;
    p {
      margin-bottom: 5px;
    }
    b {
      font-weight: 700;
    }
    li {
      p {
        color: $error;
        &.valid {
          color: $success;
        }
      }
    }
  }

  &--buttons {
    display: flex;
    align-items: center;
    gap: 10px;

    &__back {
      ::v-deep .button__fill {
        background: $pmw-white;
        color: $blue;
        border: 1px solid $blue;
      }
    }
  }

  &--button {
    width: 160px;
    display: block;
    margin: 0px auto;
  }
}

.pmw-form-field ::v-deep {
  .input--field:-webkit-autofill,
  .input--field:-webkit-autofill:hover,
  .input--field:-webkit-autofill:focus {
    box-shadow: 0 0 0px 1000px $pmw-white inset;
  }
}

.form-success {
  padding: 30px;

  &--title {
    text-align: center;
    color: $gray-darkest;
    font-weight: 500;
    margin-bottom: 5px;
  }
  &--message {
    text-align: center;
    margin-bottom: 17px;
    color: $gray-darkest;
    line-height: 21px;
  }
  &--icon {
    background: pmw-colors('primary-120');
    border-radius: 100%;
    color: $pmw-white;
    width: 34px;
    height: 34px;
    padding: 10px;
    display: block;
    margin: 0px auto;
  }

  &--button {
    width: 90px;
    display: block;
    margin: 17px auto 0px auto;
  }
}

.link {
  color: $blue;
  cursor: pointer;
}
</style>
